import { z } from "zod";

const optionalText = z.string().trim().nullable();
const website = z
  .string()
  .trim()
  .refine((value) => !value || /^https?:\/\//i.test(value), "Use an http:// or https:// URL.")
  .nullable();
export const personInputSchema = z
  .object({
    name: z.string().trim().min(1, "Name is required."),
    firstName: optionalText,
    lastName: optionalText,
    companyId: z.uuid().nullable(),
    location: optionalText,
    publicEmail: z.email().nullable(),
    phoneNumber: optionalText.optional(),
    website,
    bio: optionalText,
  })
  .strict();
export const companyInputSchema = z
  .object({
    name: z.string().trim().min(1, "Name is required."),
    domain: optionalText,
    url: website,
  })
  .strict();
export type PersonInput = z.infer<typeof personInputSchema>;
export type CompanyInput = z.infer<typeof companyInputSchema>;
